var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.loggedIn ? ' cursor-pointer' : '',attrs:{"alt":"image","src":_vm.content ? _vm.content.content[_vm.size] : _vm.placeholder},on:{"click":_vm.onClickImage}})}
var staticRenderFns = []

export { render, staticRenderFns }